/**
 * §dashboard-view · Dizionario UNICO valori→etichette per tutte le
 * enumerazioni del questionario VALUTA. Coerente con
 * backend/services/vg2/valuta_questionnaire.py. Usato da lista e dettaglio
 * della dashboard proprietari per NON mostrare mai valori interni
 * (es. "owner_occupied", "ground", "internal").
 */
export const ENUM_LABELS = {
  property_type: {
    apartment: "Appartamento",
    detached_house: "Casa indipendente / villa",
    other_residential: "Altro residenziale",
    residential: "Residenziale",
  },
  condition: {
    excellent: "Ottimo",
    good: "Buono",
    to_renovate: "Da ristrutturare",
    // alias italiani già presenti in alcuni dati salvati
    buono: "Buono",
    ottimo: "Ottimo",
    da_ristrutturare: "Da ristrutturare",
    ristrutturato: "Ristrutturato",
  },
  floor: {
    basement: "Seminterrato",
    ground: "Piano terra",
    first: "Primo piano",
    intermediate: "Piano intermedio",
    top: "Ultimo piano / attico",
    multi_level: "Su più livelli",
    // valori residui presenti in alcuni dati salvati
    attico: "Ultimo piano / attico",
    "1": "Primo piano",
    "2": "Secondo piano",
    "3": "Terzo piano",
  },
  exposure: {
    north: "Nord",
    south: "Sud",
    east: "Est",
    west: "Ovest",
    double: "Doppia esposizione",
    unknown: "Non indicata",
  },
  brightness: {
    high: "Molto luminoso",
    medium: "Nella media",
    low: "Poco luminoso",
    unknown: "Non indicata",
  },
  view: {
    open: "Aperta / panoramica",
    standard: "Normale",
    internal: "Su cortile o interna",
    unknown: "Non indicata",
  },
  occupancy: {
    free: "Libero",
    owner_occupied: "Occupato da me / famiglia",
    rented: "Locato a terzi",
    other: "Altra situazione",
  },
  bool_ynu: {
    yes: "Sì",
    no: "No",
    unknown: "Non indicato",
    true: "Sì",
    false: "No",
  },
  // §dashboard-view · chiavi scenario (Storico DECIDI). Il backend invia
  // quasi sempre un titolo leggibile; questa mappa è il fallback per non
  // mostrare mai la chiave grezza (UPPER_SNAKE / lower_snake, _norm le
  // porta a minuscolo).
  scenario_key: {
    sell_now: "Vendere nello stato attuale",
    sell_as_is: "Vendere nello stato attuale",
    prepare_then_sell: "Preparare e vendere",
    renovate_then_sell: "Ristrutturare e vendere",
    long_term_rent: "Affitto a lungo termine",
    short_term_rent: "Locazione turistica / B&B",
    student_rent: "Affitto a studenti",
    split_and_sell: "Frazionare e vendere",
    hold: "Mantenere",
    renovate_and_split_then_sell: "Ristrutturare, frazionare e vendere",
    renovate_then_long_term_rent: "Ristrutturare e affittare a lungo termine",
    prepare_and_split_then_sell: "Preparare, frazionare e vendere",
    renovate_then_student_rent: "Ristrutturare e affittare a studenti",
    split_then_long_term_rent: "Frazionare e affittare a lungo termine",
    split_sell_and_rent: "Frazionare: vendere un'unità e affittare l'altra",
    renovate_then_short_term_rent: "Lavori e poi locazione turistica / B&B",
    open_idea: "Altra strada da valutare",
  },
};

// Etichette in italiano dei campi (coerenti col questionario).
export const FEATURE_LABELS = {
  surface_sqm: "Superficie",
  property_type: "Tipologia",
  condition: "Stato",
  floor: "Piano",
  floors_total: "Piani totali edificio",
  rooms: "Locali",
  bedrooms: "Camere",
  bathrooms: "Bagni",
  year_built: "Anno di costruzione",
  exposure: "Esposizione",
  brightness: "Luminosità",
  view: "Vista",
  occupancy: "Stato di occupazione",
  elevator: "Ascensore",
  balcony: "Balcone",
  terrace: "Terrazzo",
  garden: "Giardino",
  box: "Box auto",
  cellar: "Cantina",
  attic: "Soffitta / mansarda",
  parking: "Posto auto",
};

// §dashboard-view · Opzioni canoniche dei menu a tendina del modulo di
// modifica (valore interno invariato, etichetta italiana). Coerenti con
// backend/services/vg2/valuta_questionnaire.py (*_CHOICES). Punto UNICO
// riutilizzabile: i componenti non devono mai dichiarare i valori a mano.
export const FEATURE_OPTIONS = {
  condition: [
    { value: "excellent", label: "Ottimo" },
    { value: "good", label: "Buono" },
    { value: "to_renovate", label: "Da ristrutturare" },
  ],
  floor: [
    { value: "basement", label: "Seminterrato" },
    { value: "ground", label: "Piano terra" },
    { value: "first", label: "Primo piano" },
    { value: "intermediate", label: "Piano intermedio" },
    { value: "top", label: "Ultimo piano / attico" },
    { value: "multi_level", label: "Su più livelli" },
  ],
  exposure: [
    { value: "north", label: "Nord" },
    { value: "south", label: "Sud" },
    { value: "east", label: "Est" },
    { value: "west", label: "Ovest" },
    { value: "double", label: "Doppia esposizione" },
    { value: "unknown", label: "Non lo so" },
  ],
  brightness: [
    { value: "high", label: "Molto luminoso" },
    { value: "medium", label: "Nella media" },
    { value: "low", label: "Poco luminoso" },
    { value: "unknown", label: "Non lo so" },
  ],
  view: [
    { value: "open", label: "Aperta / panoramica" },
    { value: "standard", label: "Normale" },
    { value: "internal", label: "Su cortile o interna" },
    { value: "unknown", label: "Non lo so" },
  ],
  occupancy: [
    { value: "free", label: "Libero" },
    { value: "owner_occupied", label: "Occupato da me / famiglia" },
    { value: "rented", label: "Locato a terzi" },
    { value: "other", label: "Altra situazione" },
  ],
};

// §dashboard-view · Stato interno delle card scenario (Storico DECIDI).
// "ready"/"da_analizzare" sono codici interni, mai mostrati grezzi.
export const SCENARIO_STATUS_LABELS = {
  ready: "Analizzato",
  da_analizzare: "Da analizzare",
};

// Etichetta del semaforo quando usata come testo (il backend invia
// "verde/giallo/rosso" ma tolleriamo anche gli stati GREEN/AMBER/RED).
export const SEMAPHORE_LABELS = {
  verde: "Favorevole",
  giallo: "Da valutare",
  rosso: "Sconsigliato",
  green: "Favorevole",
  amber: "Da valutare",
  red: "Sconsigliato",
};

// §dashboard-view · Stato del caso lungo il percorso (JourneyState_Stage).
// Codici interni: capisci/valuta/decidi/agisci/completed/abandoned.
export const STAGE_LABELS = {
  capisci: "Inquadramento",
  valuta: "Valutazione",
  decidi: "Confronto delle strade",
  agisci: "Piano operativo",
  completed: "Completata",
  abandoned: "Interrotta",
};

const _norm = (v) => String(v).trim().toLowerCase();

/** Etichetta italiana per un valore enum. Mai il valore interno grezzo:
 * un valore sconosciuto restituisce la dicitura neutra "Non indicato"
 * (mai il codice tecnico). I numeri puri (es. piano "2") passano. */
export function enumLabel(field, value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "boolean") {
    return ENUM_LABELS.bool_ynu[String(value)] || (value ? "Sì" : "No");
  }
  const map = ENUM_LABELS[field];
  if (map && map[_norm(value)]) return map[_norm(value)];
  // numerico puro (es. piano "2") → mostra così com'è
  if (/^\d+$/.test(String(value).trim())) return String(value).trim();
  const ynu = ENUM_LABELS.bool_ynu[_norm(value)];
  if (ynu) return ynu;
  return "Non indicato";
}

export function featureLabel(field) {
  return FEATURE_LABELS[field] || field.replace(/_/g, " ");
}

/** Opzioni del menu a tendina per un campo enum. Punto UNICO: ritorna le
 * opzioni canoniche e, se il valore attualmente salvato NON è tra queste
 * (alias storico o codice sconosciuto), antepone un'opzione che PRESERVA
 * il valore interno invariato mostrandone l'etichetta leggibile
 * ("Non indicato" se davvero sconosciuto). Così il dato non viene mai
 * perso quando l'utente salva una modifica diversa. */
export function featureSelectOptions(field, value) {
  const base = FEATURE_OPTIONS[field] || [];
  const cur = value === null || value === undefined ? "" : String(value);
  if (cur && !base.some((o) => o.value === cur)) {
    return [{ value: cur, label: enumLabel(field, cur) || "Non indicato", preserved: true }, ...base];
  }
  return base;
}

/** Etichetta italiana dello stato interno di una card scenario.
 * Valore sconosciuto → "Non indicato" (mai il codice grezzo). */
export function statusLabel(value) {
  if (value === null || value === undefined || value === "") return null;
  return SCENARIO_STATUS_LABELS[_norm(value)] || "Non indicato";
}

/** Etichetta leggibile del semaforo. Valore sconosciuto → "Non indicato". */
export function semaphoreLabel(value) {
  if (value === null || value === undefined || value === "") return null;
  return SEMAPHORE_LABELS[_norm(value)] || "Non indicato";
}

/** Etichetta italiana dello stato del caso. Valore vuoto o sconosciuto →
 * null (il chiamante mostra il proprio testo neutro, es. "in corso"):
 * non si mostra mai il codice grezzo. */
export function stageLabel(value) {
  if (value === null || value === undefined || value === "") return null;
  return STAGE_LABELS[_norm(value)] || null;
}
